export default __webpack_public_path__ + "static/media/icon-camera-celcom.240cf09b.svg";